"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginManagerBase_1 = require("../PluginManagerBase");
const WidgetError_1 = require("../../Error/WidgetError");
/**
 * Widget step plugin manager.
 */
class WidgetStepPluginManager extends PluginManagerBase_1.default {
    /**
     * @inheritDoc
     */
    validate() {
        super.validate();
        if (!this.definitions || !this.definitions.length) {
            throw new WidgetError_1.default(`Widget built with no steps.`);
        }
    }
    /**
     * Gets the index of the step.
     *
     * @return number
     */
    getStepIndex(step) {
        return this.definitions.sort((a, b) => b.getPriority() - a.getPriority())
            .indexOf(step) + 1;
    }
}
exports.default = WidgetStepPluginManager;
